module.exports = __webpack_public_path__ + "static/media/sleepnix-4.ea0a6abe.jpg";